import { h, render, Component } from "preact";

// Don't forget to bump LAST_SEASON every year.
const FIRST_SEASON = 1977;
const LAST_SEASON = 2024;

const ALL_SEASONS = new Array(LAST_SEASON + 1 - FIRST_SEASON)
  .fill()
  .map((d, i) => i + FIRST_SEASON)
  .reverse();
// until I can get all playoff data filled
const PLAYOFF_SEASONS = [2017];

export default class SeasonSelector extends Component {
  constructor(props) {
    props.selectedYear = props.selectedYear || LAST_SEASON;
    props.isPlayoffs = props.isPlayoffs || false;
    super(props);

    this.handleSeasonChange = this.handleSeasonChange.bind(this);
  }

  handleSeasonChange(e) {
    this.props.onSeasonChange(e.target.value);
  }

  render(props, state) {
    const availableSeasons = this.props.isPlayoffs
      ? PLAYOFF_SEASONS
      : ALL_SEASONS;
    const seasonOptions = availableSeasons.map(s => {
      const seasonName = `${s}-${s + 1} Season`;
      return (
        <option selected={s === props.selectedYear} value={s}>
          {seasonName}
        </option>
      );
    });

    return (
      <select name="current_season" onChange={this.handleSeasonChange}>
        {seasonOptions}
      </select>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/season-selector-component.js